const WIDGET_SCRIPT_ID = 'igna-chat-widget-script';
const WIDGET_CONTAINER_ID = 'igna-chat-widget-container';

export function removeWidgetScript(): void {
  document.getElementById(WIDGET_SCRIPT_ID)?.remove();
}

export function removeWidgetArtifacts(): void {
  removeWidgetScript();
  document.getElementById(WIDGET_CONTAINER_ID)?.remove();
}

export function injectWidgetScript(location: string): HTMLScriptElement {
  removeWidgetArtifacts();

  const script = document.createElement('script');
  script.id = WIDGET_SCRIPT_ID;
  script.src = 'https://igna-chat.igna.ai/igna-chat-widgets-demo/chat-widget.min.js';
  script.setAttribute('data-location', location);
  document.body.appendChild(script);

  return script;
}
